import { render, staticRenderFns } from "./FormPropertyOwnerComponent.vue?vue&type=template&id=de0ff024"
import script from "./FormPropertyOwnerComponent.vue?vue&type=script&lang=js"
export * from "./FormPropertyOwnerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports